import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ComponentWillMountSymbol } from 'feature-components'
import {
	ExternalComponentLoaderSymbol,
	PartytownLoaderSymbol,
	TrustedExternalComponentLoaderSymbol,
	UntrustedExternalComponentLoaderSymbol,
} from './symbols'
import { ExternalComponentLoader } from './componentsLoader/externalComponentLoader'
import { TrustedExternalComponentLoader } from './componentsLoader/trustedExternalComponentLoader'
import { UntrustedExternalComponentLoader } from './componentsLoader/untrustedExternalComponentLoader'
import { ExternalComponentWillMount } from './externalComponentWillMount'
import { ViewerPartytownLoader } from './viewer/viewerPartytownLoader'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(ExternalComponentWillMount)
}

export const site: ContainerModuleLoader = (bind) => {
	bind(PartytownLoaderSymbol).to(ViewerPartytownLoader)

	bind(TrustedExternalComponentLoaderSymbol).to(TrustedExternalComponentLoader)
	bind(UntrustedExternalComponentLoaderSymbol).to(UntrustedExternalComponentLoader)
	bind(ExternalComponentLoaderSymbol).to(ExternalComponentLoader)
}

export { getPartytownHeadScript } from './utils/partyTownLoader'
export { getExternalComponentRendererUrl } from './utils/getExternalComponentRendererUrl'
export { ExternalComponentDsPublicApiSymbol } from './symbols'
export type { IExternalComponentDsPublicApi } from './types'
